<section class="gradient-section-theme-color1">
    <div class="container">
        <h1>
            NordNative Tools
        </h1>
    </div>
</section>

<div class="col-xs-12" style="height:50px;"></div>

<div class="container">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">NordNative Tools</li>
        </ol>
    </nav>

    <div class="mt-5">
        <div class="alert alert-info text-center" role="alert">
            <p class="mb-0">
                These tools are completely free to use and do not require any signup or personal information. Enjoy
                using
                them without any restrictions.
            </p>
        </div>
    </div>

    <div class="mt-5">
        <div class="card mt-5">
            <div class="card-header">
                <h3>Date and Time Difference Calculator Tools</h3>
            </div>
            <div class="card-body">
                <ul>
                    <li><a [routerLink]="['/tools/age-calculator']">Age Calculator</a></li>
                    <li><a [routerLink]="['/tools/date-calculator']">Date Calculator</a></li>
                    <li><a [routerLink]="['/tools/date-time-calculator']">Date and Time Calculator</a></li>
                </ul>
            </div>
        </div>

        <div class="card mt-5">
            <div class="card-header">
                <h3>Health and Fitness Tools</h3>
            </div>
            <div class="card-body">
                <ul>
                    <li><a [routerLink]="['/tools/calorie-calculator']">Calorie Calculator</a></li>
                    <li><a [routerLink]="['/tools/bmi-calculator']">BMI Calculator</a></li>
                </ul>
            </div>
        </div>

        <div class="card mt-5">
            <div class="card-header">
                <h3>Shopping Tools</h3>
            </div>
            <div class="card-body">
                <ul>
                    <li><a [routerLink]="['/tools/discount-calculator']">Discount Calculator</a></li>
                </ul>
            </div>
        </div>
    </div>

</div>

<div class="col-xs-12" style="height:50px;"></div>
